import { render } from "./BlockComponent.vue?vue&type=template&id=4219c02a&scoped=true"
import script from "./BlockComponent.vue?vue&type=script&lang=js"
export * from "./BlockComponent.vue?vue&type=script&lang=js"

import "./BlockComponent.vue?vue&type=style&index=0&id=4219c02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4219c02a"]])

export default __exports__